import { LoginOption, LoginOptionLabels } from "@/data/types";

const EXCLUDED_LOGIN_OPTIONS = [LoginOption.SMS];

export const filteredLoginOptions = (loginOptions: LoginOption[]) => {
  return loginOptions.filter(
    (option) => !EXCLUDED_LOGIN_OPTIONS.includes(option),
  );
};

export const buildSelectLoginOptions = (loginOptions: LoginOption[]) => {
  return loginOptions
    .filter((option) => !EXCLUDED_LOGIN_OPTIONS.includes(option))
    .map((option) => ({
      label: LoginOptionLabels[option],
      value: option,
    }));
};
